import { useCallback } from 'react'
import { useDispatch } from 'react-redux'

const usePromiseDispatch = () => {
  const dispatch = useDispatch()

  return useCallback(
    (fn, ...args) =>
      new Promise((resolve, reject) => {
        const callback = (isSuccess) => {
          if (isSuccess) {
            resolve()
          }
          reject()
        }
        dispatch(fn(...args, callback))
      }),
    [dispatch],
  )
}

export default usePromiseDispatch
